import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class ServicesForcecastSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.organization',
      name: 'organization',
    },
    {
      label: 'label.accountId',
      name: 'accountId',
    },
    {
      label: 'label.serviceName',
      name: 'serviceName',
    },
    {
      label: 'label.groupByAccount',
      name: 'groupByAccount',
      tOptions: 'selections:selectBool',
      isClearable: true,
      type: 'select',
    },
  ];

  btnSpan = 'col-md-12';
}

ServicesForcecastSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

ServicesForcecastSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(ServicesForcecastSearchForm);
